import React, { PropTypes, Component } from 'react'
import { searchContinentsWithProperties } from '../../sources/SearchSource'
import SearchResult from './SearchResult'
import { slugify } from '../../Utils'

class SearchByContinent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      results: []
    }
    this.handleClick = this.handleClick.bind(this)
  }

  componentWillMount () {
    searchContinentsWithProperties()
      .then(response => {
        this.setState({ results: response.data.results })
      })
      .catch(error => {
        console.log(error)
      })
  }

  handleClick (el) {
    this.props.router.push(
      '/search/region/' + slugify(el.name) + '?id=' + el.id
    )
  }

  render () {
    return (
      <SearchResult
        type={'continent'}
        router={this.props.router}
        handleClick={this.handleClick}
        results={this.state.results}
        title={'World'}
      />
    )
  }
}

SearchByContinent.propTypes = {
  user: PropTypes.object,
  router: PropTypes.object
}

export default SearchByContinent



// WEBPACK FOOTER //
// ./src/pages/Search/SearchByContinent.js